import { TextField, InputAdornment } from '@mui/material';

import { Search as SearchIcon } from '@mui/icons-material';

export interface SearchInputProps {
  name: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  error?: boolean;
  errorInfo?: string;
  autoFocus?: boolean;
}

const SearchInput = ({
                       name, placeholder, value, onChange, errorInfo, required = false, autoFocus = false, error = false,
}: SearchInputProps) => {
  return (
      <TextField
        id={name}
        //label={placeholder}
        placeholder={placeholder}
        type="search"
        variant="outlined"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoFocus={autoFocus}
        required={required}
        error={error}
        helperText={errorInfo}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          },
        }}
        fullWidth
      />
  );
};

export default SearchInput;
